import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Divider,
} from "@mui/material";

const Popup = ({ open, handleClose, data }) => {
  const { data: { details, error } = {}, success, message, status } = data;
  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className={success ? "text-green" : "text-red"}>
          {message}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {success ? (
            <p>
              We have received your enquiry and will get back to you shortly.
              Our team is excited to assist you with your requirements and
              provide the best solutions tailored to your needs.
            </p>
          ) : (
            <>
              {status !== "200" && (
                <p className="text-red">{`Error Code : ${status}`}</p>
              )}
              {error && details.length !== 0 ? (
                details?.map((item) => <p>{item?.message}</p>)
              ) : (
                <p>{details}</p>
              )}
            </>
          )}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Popup;
